import React, { useRef } from 'react';
import { Layout } from 'react-admin';

import CustomAppBar from '../CustomAppBar';
import CustomSidebar from '../CustomSidebar';
import CustomMenu from '../CustomMenu';
import Breadcrumbs, { LeaveGuardContext } from '../Breadcrumbs';

import styles from './styles.module.scss'; // eslint-disable-line no-unused-vars

// Every create, edit and show screen gets the breadcrumb back to its list (lists render none).
function CustomLayout({ children, ...props }) {
  const leaveGuard = useRef(null);
  return (
    <LeaveGuardContext.Provider value={leaveGuard}>
      <Layout {...props} menu={CustomMenu} sidebar={CustomSidebar} appBar={CustomAppBar}>
        <Breadcrumbs />
        {children}
      </Layout>
    </LeaveGuardContext.Provider>
  );
}

export default CustomLayout;
